module.exports = __webpack_public_path__ + "img/CIC.7f357900.png";